/* Quiesco — artikelpagina's: inhoudsopgave opbouwen en oude tabellen scrollbaar maken. */
(function () {
  if (window.__quiescoPage) return;
  window.__quiescoPage = true;

  function slug(text, used) {
    var base = (text || '')
      .toLowerCase()
      .replace(/[à-æ]/g, 'a')
      .replace(/[è-ë]/g, 'e')
      .replace(/[ì-ï]/g, 'i')
      .replace(/[ò-ö]/g, 'o')
      .replace(/[ù-ü]/g, 'u')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
    if (!base) base = 'deel';
    var id = base;
    var n = 2;
    while (used[id]) {
      id = base + '-' + n;
      n++;
    }
    used[id] = true;
    return id;
  }

  function wrapTables(body) {
    var tables = body.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      if (t.parentNode && t.parentNode.classList.contains('qpg-tablewrap')) continue;
      if (t.closest && t.closest('.scrollable-wrapper')) continue;
      var wrap = document.createElement('div');
      wrap.className = 'qpg-tablewrap';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    }
  }

  /* Sommige pagina's hebben zelf een inhoudsopgave in de tekst staan. Naast de
     vaste inhoudsopgave in de zijbalk is dat dubbel, dus die halen we weg —
     maar alleen als de zijbalk er ook echt is. */
  var TOC_TITLES = /^(inhoud van deze pagina|overzicht van deze pagina|in dit artikel|inhoudsopgave|inhoud)\s*:?\s*$/;

  function isTocList(el) {
    if (!el) return false;
    var t = el.tagName;
    if (t === 'UL' || t === 'OL') return !!el.querySelector('a[href^="#"]');
    if (t === 'NAV' || t === 'DIV') return !!el.querySelector('ul a[href^="#"], ol a[href^="#"]');
    return false;
  }

  function dropInlineToc(body) {
    var nodes = body.querySelectorAll('p, h2, h3, h4');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var txt = (n.textContent || '').trim().toLowerCase();
      if (!TOC_TITLES.test(txt)) continue;
      var next = n.nextElementSibling;
      while (next && next.tagName === 'P' && !(next.textContent || '').trim()) {
        var empty = next;
        next = next.nextElementSibling;
        empty.parentNode.removeChild(empty);
      }
      if (!isTocList(next)) continue;
      /* Staan de titel en de lijst samen in een eigen kader, dan haalt dat
         kader weg — anders blijft er een lege grijze doos staan. */
      var wrap = n.parentNode;
      if (wrap && wrap !== body && wrap.children.length <= 3 && wrap.contains(next) && wrap.parentNode) {
        wrap.parentNode.removeChild(wrap);
      } else {
        next.parentNode.removeChild(next);
        n.parentNode.removeChild(n);
      }
      return true;
    }
    return false;
  }

  /* Oude pagina's zetten dezelfde titel twee keer neer: één met hideonmobile en
     één met hideondesktop, zodat het lettertype per schermbreedte kan verschillen.
     In de tekst zie je er altijd maar één, maar in de inhoudsopgave kwamen ze
     allebei terecht. Daarom tellen alleen koppen die op dit scherm ook echt te
     zien zijn. Titels die twee keer voorkomen maar allebei zichtbaar zijn, blijven
     wel allebei staan: dat zijn twee echte hoofdstukken die toevallig hetzelfde
     heten. Levert het filter te weinig op — bijvoorbeeld als de stijlen nog niet
     geladen zijn en dus niets zichtbaar lijkt — dan vallen we terug op de volledige
     lijst, zodat er nooit een lege inhoudsopgave overblijft. */
  function collectHeadings(headings, used, skipHidden) {
    var items = [];
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var text = (h.textContent || '').trim();
      if (!text || text.length < 3) continue;
      if (skipHidden && !h.getClientRects().length) continue;
      if (!h.id) h.id = slug(text, used);
      items.push({ id: h.id, text: text.length > 70 ? text.slice(0, 68) + '…' : text, el: h });
    }
    return items;
  }

  function buildToc(body, toc) {
    var headings = body.querySelectorAll('h2, h1');
    var used = {};
    var items = collectHeadings(headings, used, true);
    if (items.length < 3) items = collectHeadings(headings, used, false);
    if (items.length < 3) return null;

    var ol = toc.querySelector('ol');
    var links = [];
    for (var j = 0; j < items.length; j++) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + items[j].id;
      a.textContent = items[j].text;
      li.appendChild(a);
      ol.appendChild(li);
      links.push(a);
    }
    toc.hidden = false;
    return { items: items, links: links };
  }

  function trackCurrent(toc) {
    if (!('IntersectionObserver' in window)) return;
    var map = {};
    for (var i = 0; i < toc.items.length; i++) map[toc.items[i].id] = toc.links[i];
    var visible = {};
    var obs = new IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k++) {
          visible[entries[k].target.id] = entries[k].isIntersecting;
        }
        var current = null;
        for (var m = 0; m < toc.items.length; m++) {
          if (visible[toc.items[m].id]) {
            current = toc.items[m].id;
            break;
          }
        }
        for (var id in map) {
          if (Object.prototype.hasOwnProperty.call(map, id)) {
            map[id].classList.toggle('is-current', id === current);
          }
        }
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    );
    for (var n = 0; n < toc.items.length; n++) obs.observe(toc.items[n].el);
  }

  function init() {
    var body = document.querySelector('[data-qpg-body]');
    var toc = document.querySelector('[data-qpg-toc]');
    if (!body) return;
    wrapTables(body);
    if (!toc) return;
    /* Eerst opruimen, dan opbouwen — anders zou de zijbalk kunnen verwijzen
       naar een kop die we net hebben weggehaald. We ruimen alleen op als er
       daarna nog genoeg koppen overblijven voor een zijbalk. */
    if (body.querySelectorAll('h2, h1').length > 3) dropInlineToc(body);
    var built = buildToc(body, toc);
    if (built) trackCurrent(built);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
